import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'DMI' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'DMI', label: 'Directional Movement Index', pane: 'sub', params: [14, 6], outputs: ['pdi', 'mdi', 'adx', 'adxr'] })
